import { useContext, useEffect, useState } from "react";
import MainButton from "../MainButton/MainButton";
import "./style.css";
import React from "react";
import { popupContext } from "../../../contextAdmin/Admin/Popup";
import Input from "../../Common/Input/Input";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import adminRequets from "../../api/adminRequests";
import { userContext } from "../../../contextAdmin/Admin/User";

// Creator : Team E - Chanan
function EditTeacher({ type, user_id, firstName, permissions, email, }) {
  console.log("🚀 ~ file: EditTeacher.jsx:12 ~ EditTeacher ~ type:", type)
  const { setPopup } = useContext(popupContext);
  const { user } = useContext(userContext)
  const { list, setList } = useContext(listControllerContext)
  const [message, setMessage] = useState("")
  const [userDetails, setUserDetails] = useState({
    firstName: firstName,
    permissions: permissions,
    email: email
  })
  const [mode, editMode] = useState(type == "Edit Teacher" ? "edit" : "delete")
  useEffect(() => {

    if (type == "Edit Teacher") {

    }
  }, [])

  const handleUserInput = (e) => {
    setMessage("")
    const name = e.target.name;
    const value = e.target.value;
    setUserDetails(prev => ({
      ...prev,
      [name]: value
    })
    )
  }
  function closePopup(e) {
    e.preventDefault();
    setPopup(false);
  }



  async function onSubmit(e) {
    e.preventDefault();
    setMessage("")
    try {

      if (mode == "edit") {

        let userUpdated = await adminRequets.editUserDetails(user_id, userDetails)
      } else if (mode == "delete") {

        let userUpdate = await adminRequets.deleteUser(user_id)

      }
      let newUsersList = await adminRequets.getAllTeachers()
      setList(prev => newUsersList)
      setPopup(false);
    } catch (error) {
      console.log("🚀 ~ file: EditTeacher.jsx:58 ~ onSubmit ~ error:", error)
      setMessage(error.message)
    }
  }


  // pattern={/^(admin|teacher)$/} 

  return (
    <div>
      {mode !== "edit" && user.id == user_id ? <h3>You can't delete yourself !</h3> :
        <form onSubmit={onSubmit}>
          <div >
            {mode === "edit" ?
              <>
                <Input legend={"Full name"} value={userDetails.firstName} name="firstName" onChange={handleUserInput} valid={"yes"} type={"text"} required={true} />
                <Input legend={"Email ID"} value={userDetails.email} name="email" onChange={handleUserInput} valid={"yes"} type={"email"} required={true} />
                <Input disabled={user.id == user_id} legend={"role"} value={userDetails.permissions} options={["teacher", "admin"]} type={"select"} name="permissions" placeholder={"admin/teacher"} onChange={handleUserInput} required={true} valid={"yes"} />
              </>
              : <h3>Are you sure you want to delete {userDetails.firstName + " " + userDetails.permissions + " "} ?</h3>
            }
          </div>
          <div className="popup-fotter">
            <button className="btn" type="button" onClick={closePopup}>
              Cancel
            </button>
            <button type="submit" className="btn">{mode == "edit" ? "Edit" : "Delete"}</button>
          </div>
        </form>}
      {message && <div><span>{message}</span></div>}
    </div>
  );
}
export default EditTeacher;
